import { message, Upload } from "antd";
import { USERINFO } from "@/config";
import store2 from "store2";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const timeFix = () => {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9
    ? "早上好"
    : hour <= 11
    ? "上午好"
    : hour <= 13
    ? "中午好"
    : hour < 20
    ? "下午好"
    : "晚上好";
};

export const getAuthToken = () => {
  const raw = store2(USERINFO) || {};
  let token =
    raw.token ||
    raw.admintoken ||
    raw.access_token ||
    raw.Authorization ||
    raw.salt ||
    raw.created_at ||
    raw.authToken;
  if (typeof token === "string") {
    const m = token.match(/^\s*Bearer\s+(.+)$/i);
    token = m ? m[1] : token;
  }
  console.log("raw", raw);
  const id =
    raw.id ||
    raw.adminid ||
    raw.admin_id ||
    raw.uid ||
    raw.user_id ||
    raw.userid;
  if (token && id) {
    return { token, id, isLogin: true };
  }
  return { token, id, isLogin: false };
};

export const handleRangeTime = (time) => {
  const [startTime, endTime] = time || [];
  const ST = startTime
    ? dayjs.isDayjs(startTime)
      ? startTime.format("YYYY-MM-DD")
      : dayjs(startTime)
    : "";
  const ET = endTime
    ? dayjs.isDayjs(endTime)
      ? endTime.format("YYYY-MM-DD")
      : dayjs(endTime)
    : "";
  return {
    startTime: dayjs(ST).startOf("d").unix() || undefined,
    endTime: dayjs(ET).endOf("d").unix() || undefined
  };
};

export const getFirstImage = (imgUrlsString) => {
  if (typeof imgUrlsString === "string") {
    const imgUrlsArray = imgUrlsString.split(",").filter((url) => !!url);
    return imgUrlsArray.length > 0 ? imgUrlsArray[0] : null;
  } else if (Array.isArray(imgUrlsString)) {
    return imgUrlsString.length > 0 ? imgUrlsString[0] : null;
  } else {
    return null;
  }
};

export const isStringToFilesArr = (urlString) => {
  return urlString
    ? urlString
        .split(",")
        .filter((item) => !!item)
        ?.map((item) => ({
          status: "done",
          uid: item,
          url: item,
          thumbUrl: item
        }))
    : [];
};

export const isFilesArrToString = (arr) => {
  return arr ? arr.map((img) => getUploadFilePath(img)).join(",") : "";
};

export const normFile = (e) => {
  console.log("normFile", e);
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

export const getUploadFilePath = (imgObj) => {
  if (imgObj?.response) {
    if (Array.isArray(imgObj?.response?.data)) {
      return imgObj.response.data[0];
    } else {
      return imgObj.response.data;
    }
  } else {
    return imgObj.url;
  }
};

export const formatFilePath = (imgUrl) => {
  const regExp = /^http[s]{0,1}:\/\//;
  const pathname = "upload/";
  if (regExp.test(imgUrl)) {
    const [url] = imgUrl.split("?");
    if (regExp.test(url)) {
      const [, path] = url.split(pathname);
      return `${pathname}${path}`;
    }
  }
  return imgUrl;
};

export const boolStr2Boolean = (boolStr) => {
  if (boolStr === "true") {
    return true;
  } else if (boolStr === "false") {
    return false;
  } else {
    return false;
  }
};

export const removeHttpPrefix = (url) => {
  return url ? url.replace(/^https?:\/\//i, "") : "";
};

export const haveFormData = (data) => {
  console.log(data);
  if (data === null || data === undefined || data === "") {
    return false;
  }
  const isHave = Object.entries(data).some((d) => {
    const [, value] = d;
    if (value !== undefined && value !== null && value !== "") {
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }
      return true;
    }
  });
  return isHave;
};

export const beforeUploadUtil = (file, lts = 10, isCanSvg = false) => {
  let isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    if (isCanSvg && file.type === "image/svg+xml") {
      isJpgOrPng = true;
    } else {
      message.error("上传图片格式必须为JPG/PNG!");
    }
  }
  const isLt = file.size / 1024 / 1024 < lts;
  if (!isLt) {
    message.error(`上传图片不能超过${lts}M`);
  }

  return isJpgOrPng && isLt ? true : Upload.LIST_IGNORE;
};

export const scrollToFirstError = (formRef) => {
  const formNode = formRef.current;
  if (formNode) {
    const firstErrorFieldName = formNode
      .getFieldsError()
      .find(({ errors }) => errors.length > 0);
    if (firstErrorFieldName) {
      const firstErrorField = document.body.querySelector(
        `#${firstErrorFieldName.name[0]}`
      );
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth" });
      }
    }
  }
};

export const formatDateTime = (value, format = "YYYY-MM-DD HH:mm:ss") => {
  if (value === undefined || value === null || value === "") return "--";
  let d = null;
  if (typeof value === "number") {
    const v = String(value);
    d = v.length >= 13 ? dayjs(value) : dayjs.unix(value);
  } else if (typeof value === "string") {
    const s = value.trim();
    if (/^\d+$/.test(s)) {
      d = s.length >= 13 ? dayjs(Number(s)) : dayjs.unix(Number(s));
    } else if (s.includes("T") || s.endsWith("Z")) {
      const tz = dayjs.tz ? dayjs.tz.guess() : "Asia/Shanghai";
      d = dayjs.utc(s).tz(tz);
    } else {
      d = dayjs(s);
    }
  } else if (value instanceof Date) {
    d = dayjs(value);
  } else if (dayjs.isDayjs(value)) {
    d = value;
  }
  return d && d.isValid() ? d.format(format) : "--";
};

export const formatDate = (value, format = "YYYY-MM-DD") => {
  return formatDateTime(value, format);
};
